<script>
export default {
    name: 'InquiryModal',
    data () {
        return {
            modalOpen: false
        }
    },
    computed: {
        inquiryUrl () {
            let url = import.meta.env.VITE_API ? import.meta.env.VITE_API.replace('/api/', '/inquiry/') + '?app=eve' : '/inquiry/?app=eve'
            const token = this.$ls.get('token')
            if (token) {
                url += '&token=' + token
            }
            return url
        }
    },
    watch: {
        modalOpen (val) {
            if (val) {
                window.addEventListener('message', this.fromInquiry)
            } else {
                window.removeEventListener('message', this.fromInquiry)
            }
        }
    },
    created () {
        this.$root.$on('showInquiryModal', this.showInquiry)
    },
    methods: {
        showInquiry () {
            this.$modal.show('inquiry-modal')
        },
        fromInquiry (e) {
            if (e.data === 'close') {
                this.$modal.hide('inquiry-modal')
                this.$snotify.success('問い合わせが送信されました')
            }
        },
        beforeOpen () {
            document.body.classList.add('body-no-scroll')
        },
        beforeClose () {
            document.body.classList.remove('body-no-scroll')
        },
        opened () {
            this.modalOpen = true
        },
        closed () {
            this.modalOpen = false
        }
    }
}
</script>

<template>
    <modal
        name="inquiry-modal"
        transition="nice-modal-fade"
        classes="demo-modal-class"
        :min-width="200"
        :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        :reset="true"
        width="100%"
        height="100%"
        @before-open="beforeOpen"
        @opened="opened"
        @closed="closed"
        @before-close="beforeClose"
    >
        <div class="size-modal-content d-flex justify-content-center align-items-center">
            <iframe
                v-if="modalOpen"
                :src="inquiryUrl"
                style="width: 70%; height:80vh; border-radius: 10px"
            />

            <b-btn
                close
                style="position: fixed; top: 10px; right: 10px;"
                @click="$modal.hide('inquiry-modal')"
            >
                &times;
            </b-btn>
        </div>
    </modal>
</template>

<style scoped>
.size-modal-content {
    padding: 0;
    height: 100%;
}

.v--modal-overlay {
    z-index: 9999;
    background: rgba(0, 0, 0, 0.8);
}

.demo-modal-class {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0 rgba(46, 61, 73, 0.8);
}

</style>
